export const GET_IN_LAN_DONG_LAI = "GET_IN_LAN_DONG_LAI";
export const GET_IN_LAN_DONG_LAI_SUCCESS = "GET_IN_LAN_DONG_LAI_SUCCESS";
export const GET_IN_LAN_DONG_LAI_FAILURE = "GET_IN_LAN_DONG_LAI_FAILURE";
